import React from "react";
import { NavLink } from "react-router-dom";
import ArrowUp from "../../assests/images/dashboard/chevron_forward (1).png";
import ArrowDown from "../../assests/images/dashboard/chevron_forward.png";
import TestingIcon from "../../assests/images/dashboard/order.png";
import { useAuth } from "src/contexts/auth-provider";

const SidebarItem = ({
  index,
  parentIndex,
  route,
  isSubRoute,
  sidebarOpen,
  hasDropdown,
  toggleMenu,
  isSubMenuOpen,
  setPageTitle,
}: any) => {
  const { hasRestaurant } = useAuth();
  const isExpandOnlyParent = hasDropdown && !isSubRoute;
  const resolvedTo =
    isExpandOnlyParent
      ? "/sidebar-expand-only"
      : typeof route?.url === "string"
        ? route?.url
        : route?.url?.(hasRestaurant?.correlationId, hasRestaurant?.name) ?? "#";
  const handleToggle = () => {
    if (toggleMenu) {
      if (parentIndex !== undefined) {
        toggleMenu(parentIndex, index);
      } else {
        toggleMenu(index);
      }
    }
  };
  return (
    <li className="list-none" key={index}>
      <NavLink
        to={resolvedTo}
        end={!!hasDropdown}
        className={({ isActive }) => {
          const indent = isSubRoute ? "pl-[54px]" : "";
          const activeBg = "";
          const expandedParentBg = !isSubRoute && hasDropdown && isSubMenuOpen && !isActive ? "bg-black/[0.03]" : "";
          const inactiveText = isSubRoute ? "text-[#64748b]" : "text-[#475569]";
          const baseClass = `${
            isSubRoute ? "min-h-8 max-md:min-h-11 md:h-8" : "min-h-9 max-md:min-h-11 md:h-9"
          } ${indent} ${activeBg} ${expandedParentBg} flex items-center gap-2.5 rounded-[8px] px-3 py-2 max-md:py-2.5 md:py-1.5 text-sm min-w-0 transition-[background] duration-150 ease-out ${
            isActive
              ? "font-bold text-[#f97316]"
              : `font-medium ${inactiveText} hover:bg-black/[0.05] dark:text-slate-400 dark:hover:bg-white/10`
          }`;
          return baseClass;
        }}
        onClick={(e) => {
          if (hasDropdown && !isSubRoute) {
            e.preventDefault();
          }
          handleToggle();
          setPageTitle(route?.name);
        }}
      >
        {({ isActive }) => (
          <>
            <div className="flex min-w-0 flex-1 items-center gap-2.5">
              {route?.icon && (
                <span className={`flex h-[16px] w-[16px] shrink-0 items-center justify-center [&>svg]:h-[16px] [&>svg]:w-[16px] ${!isActive ? "opacity-75" : ""}`}>
                  {route.name === "Orders" ? (
                    <img
                      className={`h-[16px] w-[16px] ${
                        isActive
                          ? "active-recent-order"
                          : "active-recent-order-default"
                      }`}
                      src={TestingIcon}
                      alt=""
                    />
                  ) : (
                    <route.icon color={isActive ? "#f97316" : "#94a3b8"} />
                  )}
                </span>
              )}
              {sidebarOpen && (
                <span className="truncate">{route?.name}</span>
              )}
            </div>
            {sidebarOpen && hasDropdown && (
              <div className="ml-auto shrink-0">
                <img
                  alt=""
                  className="h-2 w-[15px]"
                  src={isSubMenuOpen ? ArrowUp : ArrowDown}
                />
              </div>
            )}
          </>
        )}
      </NavLink>
    </li>
  );
};

export default SidebarItem;
